enum Nips {
  Search = 50,
}

export default Nips;
